const roles = {'Crew': 1, 'Reception': 2, 'Teamlead': 3, 'Admin': 4};
export default roles
export function roleName(role) {
    return Object.keys(roles).find(key =>roles[key] === role);
}